var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLollyCopyButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5H24C28.1421 0.5 31.5 3.85786 31.5 8V24C31.5 28.1421 28.1421 31.5 24 31.5H8C3.85786 31.5 0.5 28.1421 0.5 24V8C0.5 3.85786 3.85786 0.5 8 0.5Z",
    fill: "#3C1E64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5H24C28.1421 0.5 31.5 3.85786 31.5 8V24C31.5 28.1421 28.1421 31.5 24 31.5H8C3.85786 31.5 0.5 28.1421 0.5 24V8C0.5 3.85786 3.85786 0.5 8 0.5Z",
    stroke: "#E76EFF",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "lollyCopyMask",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8412 7.66699H16.3412C13.7719 7.66699 12.567 8.57873 12.3159 10.7828C12.2634 11.2439 12.6453 11.6253 13.1094 11.6253H14.8412C18.3412 11.6253 19.9662 13.2503 19.9662 16.7503V18.4821C19.9662 18.9462 20.3475 19.3281 20.8086 19.2755C23.0127 19.0245 23.9245 17.8196 23.9245 15.2503V11.7503C23.9245 8.83366 22.7578 7.66699 19.8412 7.66699Z",
    fill: "#F1E7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9245 16.7503V20.2503C18.9245 23.167 17.7578 24.3337 14.8411 24.3337H11.3411C8.42448 24.3337 7.25781 23.167 7.25781 20.2503V16.7503C7.25781 13.8337 8.42448 12.667 11.3411 12.667H14.8411C17.7578 12.667 18.9245 13.8337 18.9245 16.7503Z",
    fill: "#F1E7FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#lollyCopyMask)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#E3CDFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLollyCopyButton);
export default __webpack_public_path__ + "static/media/lolly-copy-button.b8de80fbcf448da3306f312a018517b1.svg";
export { ForwardRef as ReactComponent };